<template>
  <section class="form-surface">
    <div class="form-panel">
      <h1>Register</h1>
      <div v-if="message" class="workspace-alert">{{ message }}</div>
      <p v-if="!session.userRegistrationEnabled">User registration is disabled.</p>
      <form v-else @submit.prevent="register">
        <label class="form-row">
          <span>Name</span>
          <input v-model="name" />
        </label>
        <label class="form-row">
          <span>Email</span>
          <input v-model="email" type="email" autocomplete="email" />
        </label>
        <label class="form-row">
          <span>Password</span>
          <input v-model="password" type="password" />
        </label>
        <button type="submit">Register</button>
        <div class="form-actions muted-actions">
          <RouterLink class="app-link" to="/login">Back to login</RouterLink>
        </div>
      </form>
    </div>
  </section>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { RouterLink } from 'vue-router';
import { CommandsService } from '../api/generated';
import { getErrorMessage, useSessionStore } from '../stores/session';
import {
  validateRequiredEmail,
  validateRequiredPassword,
  validateRequiredUserName
} from '../validation/userValidation';

const session = useSessionStore();
const name = ref('');
const email = ref('');
const password = ref('');
const message = ref<string | null>(null);

async function register(): Promise<void> {
  const validationMessage = validateRegister();
  if (validationMessage != null) {
    message.value = validationMessage;
    return;
  }

  try {
    await CommandsService.commandRegisterUserCommand({
      requestBody: {
        name: name.value.trim(),
        email: email.value.trim(),
        password: password.value
      }
    });
    message.value = 'Registration created. Check your email to verify the account.';
  } catch (error) {
    message.value = getErrorMessage(error, 'Unable to register.');
  }
}

function validateRegister(): string | null {
  return validateRequiredUserName(name.value)
    ?? validateRequiredEmail(email.value)
    ?? validateRequiredPassword(password.value);
}
</script>
